/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Citizen } from '../models';
// @ts-ignore
import type { InputSetIseeCertifiedValues } from '../models';
// @ts-ignore
import type { ResponseGetAdminCitizenById } from '../models';
// @ts-ignore
import type { ResponseGetCitizenCountToReset } from '../models';
// @ts-ignore
import type { ResponseResetCitizenIseeChangeYear } from '../models';
/**
 * AdminCitizenApi - axios parameter creator
 * @export
 */
export const AdminCitizenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary All customers | Permission required: [\"readAll\", \"Citizen\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {string} [isBuyer] 
         * @param {boolean} [_export] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCustomers: async (filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, isBuyer?: string, _export?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/citizen/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (registeredBeforeDate !== undefined) {
                localVarQueryParameter['registeredBeforeDate'] = registeredBeforeDate;
            }

            if (registeredAfterDate !== undefined) {
                localVarQueryParameter['registeredAfterDate'] = registeredAfterDate;
            }

            if (isBuyer !== undefined) {
                localVarQueryParameter['isBuyer'] = isBuyer;
            }

            if (_export !== undefined) {
                localVarQueryParameter['export'] = _export;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete citizen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCitizen: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCitizen', 'id', id)
            const localVarPath = `/admin/citizen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"Citizen\"] 
         * @summary Get admin citizen by id | Permission required: [\"readOne\", \"Citizen\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCitizenById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminCitizenById', 'id', id)
            const localVarPath = `/admin/citizen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get citizen count to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizenCountToReset: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/citizen/reset-year/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset citizen isee change year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCitizenIseeChangeYear: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/citizen/reset-year/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"Citizen\"] 
         * @summary Set ordinary and current certified values for isee
         * @param {number} id 
         * @param {InputSetIseeCertifiedValues} [inputSetIseeCertifiedValues] Set ordinary and current certified values for isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIseeCertifiedValues: async (id: number, inputSetIseeCertifiedValues?: InputSetIseeCertifiedValues, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setIseeCertifiedValues', 'id', id)
            const localVarPath = `/admin/citizen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSetIseeCertifiedValues, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCitizenApi - functional programming interface
 * @export
 */
export const AdminCitizenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCitizenApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary All customers | Permission required: [\"readAll\", \"Citizen\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {string} [isBuyer] 
         * @param {boolean} [_export] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allCustomers(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, isBuyer?: string, _export?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Citizen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allCustomers(filter, registeredBeforeDate, registeredAfterDate, isBuyer, _export, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.allCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete citizen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCitizen(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCitizen(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.deleteCitizen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"Citizen\"] 
         * @summary Get admin citizen by id | Permission required: [\"readOne\", \"Citizen\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCitizenById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetAdminCitizenById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCitizenById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.getAdminCitizenById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get citizen count to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCitizenCountToReset(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetCitizenCountToReset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCitizenCountToReset(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.getCitizenCountToReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset citizen isee change year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetCitizenIseeChangeYear(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseResetCitizenIseeChangeYear>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetCitizenIseeChangeYear(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.resetCitizenIseeChangeYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"Citizen\"] 
         * @summary Set ordinary and current certified values for isee
         * @param {number} id 
         * @param {InputSetIseeCertifiedValues} [inputSetIseeCertifiedValues] Set ordinary and current certified values for isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIseeCertifiedValues(id: number, inputSetIseeCertifiedValues?: InputSetIseeCertifiedValues, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Citizen>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIseeCertifiedValues(id, inputSetIseeCertifiedValues, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCitizenApi.setIseeCertifiedValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCitizenApi - factory interface
 * @export
 */
export const AdminCitizenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCitizenApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary All customers | Permission required: [\"readAll\", \"Citizen\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [registeredBeforeDate] 
         * @param {string} [registeredAfterDate] 
         * @param {string} [isBuyer] 
         * @param {boolean} [_export] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCustomers(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, isBuyer?: string, _export?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<Citizen>> {
            return localVarFp.allCustomers(filter, registeredBeforeDate, registeredAfterDate, isBuyer, _export, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete citizen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCitizen(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCitizen(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"Citizen\"] 
         * @summary Get admin citizen by id | Permission required: [\"readOne\", \"Citizen\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCitizenById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetAdminCitizenById> {
            return localVarFp.getAdminCitizenById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get citizen count to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizenCountToReset(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetCitizenCountToReset> {
            return localVarFp.getCitizenCountToReset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset citizen isee change year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCitizenIseeChangeYear(options?: RawAxiosRequestConfig): AxiosPromise<ResponseResetCitizenIseeChangeYear> {
            return localVarFp.resetCitizenIseeChangeYear(options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Citizen\"] 
         * @summary Set ordinary and current certified values for isee
         * @param {number} id 
         * @param {InputSetIseeCertifiedValues} [inputSetIseeCertifiedValues] Set ordinary and current certified values for isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIseeCertifiedValues(id: number, inputSetIseeCertifiedValues?: InputSetIseeCertifiedValues, options?: RawAxiosRequestConfig): AxiosPromise<Citizen> {
            return localVarFp.setIseeCertifiedValues(id, inputSetIseeCertifiedValues, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCitizenApi - interface
 * @export
 * @interface AdminCitizenApi
 */
export interface AdminCitizenApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Citizen\"] 
     * @summary All customers | Permission required: [\"readAll\", \"Citizen\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [registeredBeforeDate] 
     * @param {string} [registeredAfterDate] 
     * @param {string} [isBuyer] 
     * @param {boolean} [_export] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    allCustomers(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, isBuyer?: string, _export?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<Citizen>>;

    /**
     * 
     * @summary Delete citizen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    deleteCitizen(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     *  **Permission required**: [\"readOne\", \"Citizen\"] 
     * @summary Get admin citizen by id | Permission required: [\"readOne\", \"Citizen\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    getAdminCitizenById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetAdminCitizenById>;

    /**
     * 
     * @summary Get citizen count to reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    getCitizenCountToReset(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetCitizenCountToReset>;

    /**
     * 
     * @summary Reset citizen isee change year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    resetCitizenIseeChangeYear(options?: RawAxiosRequestConfig): AxiosPromise<ResponseResetCitizenIseeChangeYear>;

    /**
     *  **Permission required**: [\"update\", \"Citizen\"] 
     * @summary Set ordinary and current certified values for isee
     * @param {number} id 
     * @param {InputSetIseeCertifiedValues} [inputSetIseeCertifiedValues] Set ordinary and current certified values for isee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApiInterface
     */
    setIseeCertifiedValues(id: number, inputSetIseeCertifiedValues?: InputSetIseeCertifiedValues, options?: RawAxiosRequestConfig): AxiosPromise<Citizen>;

}

/**
 * AdminCitizenApi - object-oriented interface
 * @export
 * @class AdminCitizenApi
 * @extends {BaseAPI}
 */
export class AdminCitizenApi extends BaseAPI implements AdminCitizenApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Citizen\"] 
     * @summary All customers | Permission required: [\"readAll\", \"Citizen\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [registeredBeforeDate] 
     * @param {string} [registeredAfterDate] 
     * @param {string} [isBuyer] 
     * @param {boolean} [_export] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public allCustomers(filter?: string, registeredBeforeDate?: string, registeredAfterDate?: string, isBuyer?: string, _export?: boolean, options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).allCustomers(filter, registeredBeforeDate, registeredAfterDate, isBuyer, _export, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete citizen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public deleteCitizen(id: number, options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).deleteCitizen(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"Citizen\"] 
     * @summary Get admin citizen by id | Permission required: [\"readOne\", \"Citizen\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public getAdminCitizenById(id: number, options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).getAdminCitizenById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get citizen count to reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public getCitizenCountToReset(options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).getCitizenCountToReset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset citizen isee change year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public resetCitizenIseeChangeYear(options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).resetCitizenIseeChangeYear(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"Citizen\"] 
     * @summary Set ordinary and current certified values for isee
     * @param {number} id 
     * @param {InputSetIseeCertifiedValues} [inputSetIseeCertifiedValues] Set ordinary and current certified values for isee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCitizenApi
     */
    public setIseeCertifiedValues(id: number, inputSetIseeCertifiedValues?: InputSetIseeCertifiedValues, options?: RawAxiosRequestConfig) {
        return AdminCitizenApiFp(this.configuration).setIseeCertifiedValues(id, inputSetIseeCertifiedValues, options).then((request) => request(this.axios, this.basePath));
    }
}

